import {
  StyledRadioButton,
  StyledRadio,
  StyledRoundRadioButton,
  StyledRoundRadioButtonWrapper,
  StyledRoundRadio,
} from './StyledRadio';

export const Radio = ({
  variants = [],
  selected = -1,
  fn,
  disabled = false,
  style = null,
}) => {
  const handleClick = index => () => {
    selected !== index ? fn(index) : fn('');
  };
  return (
    <StyledRadio style={style}>
      {variants.map((variant, i) => (
        <StyledRadioButton
          key={i}
          className={selected === i ? 'selected' : ''}
          onClick={handleClick(i)}
          disabled={disabled}
        >
          {variant}
        </StyledRadioButton>
      ))}
    </StyledRadio>
  );
};

export const RoundRadio = ({
  variants = [],
  selected = 0,
  fn,
  square = false,
  small = false,
  multy = false,
}) => {
  const handleClick = index => () => {
    let newSelected = selected;
    if (multy) {
      const checkedSelected = selected.filter(el =>
        variants.some(variant => variant === el),
      );
      if (checkedSelected.some(el => el === variants[index]))
        newSelected = [...checkedSelected.filter(el => el !== variants[index])];
      else newSelected = [...checkedSelected, variants[index]];
      console.log(newSelected);
      fn(newSelected);
    } else {
      if (!square) selected !== index + 1 && fn(index + 1);
      else fn(index + 1);
    }
  };
  return (
    <StyledRoundRadio>
      {variants.map((variant, i) => (
        <StyledRoundRadioButtonWrapper key={i}>
          <StyledRoundRadioButton
            className={
              multy
                ? selected.some(el => el === variant)
                  ? 'selected circle'
                  : 'circle'
                : selected === i + 1
                ? 'selected circle'
                : 'circle'
            }
            onClick={handleClick(i)}
            square={square}
          ></StyledRoundRadioButton>
          <span className={small ? 'text small' : 'text'}>{variant}</span>
        </StyledRoundRadioButtonWrapper>
      ))}
    </StyledRoundRadio>
  );
};
